import {
    Button,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Form,
    FormGroup,
    Input,
} from 'reactstrap';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../context';
import moment from 'moment';
import SuccessConfirmationModal from '../../SuccessConfirmationModal';
import { Facebook } from 'react-spinners-css';

const pluginStatuses = [
    { label: 'Present In Manifest', value: 'Present In Manifest' },
    { label: 'Cached', value: 'Cached' },
    { label: 'Installed', value: 'Installed' },
    { label: 'Running', value: 'Running' },
];

const EditPluginModal = (props) => {
    const { isOpen, closeModal, plugin, refreshManifest } = props;

    const [defaultStateValue, setDefaultStateValue] = useState('');
    const [versionContent, setVersionContent] = useState();
    const [statusContent, setStatusContent] = useState();
    const [notesContent, setNotesContent] = useState();
    const [pluginVersions, setPluginVersions] = useState([]);
    const [isLoadingVersions, setIsLoadingVersions] = useState(true);
    const [isAwaitingResponse, setIsAwaitingResponse] = useState(false);
    const [isSuccessConfirmationModalOpen, setIsSuccessConfirmationModalOpen] =
        useState(false);
    const [editPluginResponse, setEditPluginResponse] = useState();

    const dispatch = useDispatch();

    const instanceId = useSelector(
        (state) => state.practice?.practice?.instanceId
    );

    useEffect(() => {
        if (plugin !== null && plugin !== undefined) {
            setIsLoadingVersions(true);

            //set values
            setDefaultStateValue(getGeneralStatus(plugin.status));
            setVersionContent({
                content: plugin.version,
                isChanged: false,
            });
            setStatusContent({
                content: plugin.status,
                isChanged: false,
            });
            setNotesContent({
                content: plugin.notes,
                isChanged: false,
            });

            dispatch(actions.missionControl.getPluginVersions(plugin.uid)).then(
                (res) => {
                    setPluginVersions(res || []);
                    setIsLoadingVersions(false);
                }
            );
        }
    }, [dispatch, plugin]);

    const onVersionContentChanged = (e) =>
        setVersionContent({
            content: e.target.value,
            isChanged: e.target.value !== plugin.version,
        });

    const onStatusContentChanged = (e) => {
        setStatusContent({
            content: getDiscreteStatuses(e.target.value),
            isChanged: e.target.value !== getGeneralStatus(plugin.status),
        });
    };

    const onNotesContentChanged = (e) =>
        setNotesContent({
            content: e.target.value,
            isChanged: e.target.value !== plugin.notes,
        });

    const handleCloseModal = () => {
        resetStatetoInit();
        closeModal();
    };

    const handleSubmit = () => {
        setIsAwaitingResponse(true);

        //TODO: figure out a way to implement this so that this doesn't have to be updated everytime a new property is added to the plugin
        dispatch(
            actions.clientPlugins.updateClientPlugin(instanceId, {
                targetedPluginId: plugin.uid,
                targetedPluginVersion: plugin.version,
                clientPluginUpdate: {
                    pluginId: plugin.uid,
                    pluginVersion: versionContent.content,
                    status: statusContent.content,
                    notes: notesContent.content,
                    startupTimeout: plugin.startupTimeout, //TODO: set from form
                    configuration: plugin.configuration,
                },
            })
        )
            .then((res) => {
                refreshManifest();
                setEditPluginResponse(res);
            })
            .then(() => {
                setIsAwaitingResponse(false);
                closeModal();
                setIsSuccessConfirmationModalOpen(true);
            });
    };

    const resetStatetoInit = () => {
        setVersionContent({
            content: plugin.version,
            isChanged: false,
        });
        setStatusContent({
            content: plugin.status,
            isChanged: false,
        });
        setNotesContent({
            content: plugin.notes,
            isChanged: false,
        });
    };

    return (
        <>
            <SuccessConfirmationModal
                isOpen={isSuccessConfirmationModalOpen}
                successResponse={editPluginResponse}
                closeBehavior={() => setIsSuccessConfirmationModalOpen(false)}
            />
            <Modal isOpen={isOpen} centered className="text-light">
                <ModalHeader>Edit Plugin:</ModalHeader>
                <ModalBody>
                    {isLoadingVersions ? (
                        <h2 className="m-4 text-center">
                            <Facebook color="#eee" />
                        </h2>
                    ) : (
                        <Form>
                            <FormGroup>
                                <Label>Plugin</Label>
                                <Input
                                    placeholder={plugin.name}
                                    readOnly></Input>
                            </FormGroup>
                            <FormGroup>
                                <Label for="plugin-version">Version</Label>
                                {plugin.isInherited ? (
                                    <Input
                                        placeholder={plugin.version}
                                        readOnly></Input>
                                ) : (
                                    <Input
                                        type="select"
                                        id="plugin-version"
                                        defaultValue={plugin?.version}
                                        onChange={onVersionContentChanged}
                                        {...(versionContent.isChanged && {
                                            style: {
                                                backgroundColor:
                                                    'var(--yellow)',
                                            },
                                        })}>
                                        {pluginVersions.map((pluginVersion) => (
                                            <option
                                                key={pluginVersion.version}
                                                value={pluginVersion.version}>
                                                {GetPluginVersionDisplayDetails(
                                                    pluginVersion
                                                )}
                                            </option>
                                        ))}
                                    </Input>
                                )}
                            </FormGroup>
                            <FormGroup>
                                <Label for="plugin-state">Status</Label>
                                <Input
                                    type="select"
                                    id="plugin-state"
                                    defaultValue={defaultStateValue}
                                    onChange={onStatusContentChanged}
                                    {...(statusContent.isChanged && {
                                        style: {
                                            backgroundColor: 'var(--yellow)',
                                        },
                                    })}>
                                    {pluginStatuses.map((pluginStatus) => (
                                        <option
                                            key={pluginStatus.value}
                                            value={pluginStatus.value}>
                                            {pluginStatus.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label>Notes</Label>
                                <Input
                                    type="textarea"
                                    value={
                                        notesContent.content
                                            ? notesContent.content
                                            : ''
                                    }
                                    onChange={onNotesContentChanged}
                                    {...(notesContent.isChanged && {
                                        style: {
                                            backgroundColor: 'var(--yellow)',
                                        },
                                    })}></Input>
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="danger"
                        disabled={isAwaitingResponse}
                        onClick={() => handleCloseModal()}>
                        Cancel
                    </Button>
                    <Button
                        color={isAwaitingResponse ? 'secondary' : 'success'}
                        disabled={isAwaitingResponse}
                        onClick={() => handleSubmit()}>
                        {isAwaitingResponse ? 'Saving...' : 'Save'}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

const getDiscreteStatuses = (status) => {
    switch (status) {
        case 'Cached':
            return {
                isCached: true,
                isInstalled: false,
                isRunning: false,
            };
        case 'Installed':
            return {
                isCached: true,
                isInstalled: true,
                isRunning: false,
            };
        case 'Running':
            return {
                isCached: true,
                isInstalled: true,
                isRunning: true,
            };
        case 'Present In Manifest':
            return {
                isCached: false,
                isInstalled: false,
                isRunning: false,
            };
    }
};

const getGeneralStatus = (statusObj) => {
    if (statusObj.isRunning) {
        return 'Running';
    } else if (statusObj.isInstalled) {
        return 'Installed';
    } else if (statusObj.isCached) {
        return 'Cached';
    }

    return 'Present In Manifest';
};

const truncateString = (str, maxLength) => {
    if (str.length <= maxLength) {
        return str;
    }

    return str.slice(0, maxLength) + '...';
};

const GetPluginVersionDisplayDetails = (pluginVersion) => {
    return (
        pluginVersion?.version +
        ' - ' +
        truncateString(pluginVersion.description, 40) +
        ` (${moment
            .utc(pluginVersion?.releaseDate)
            .local()
            .format('M/D/YYYY LT')})`
    );
};

export default EditPluginModal;
